"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = _interopRequireDefault(require("../utils/createStyles"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread({}, (0, _createStyles.default)('backgroundColor', theme.palette)), {}, {
  autocomplete: {
    position: 'relative',
    paddingTop: 17,
    paddingBottom: 20,
    color: theme.textColor,
    '& input': {
      color: theme.textColor,
      backgroundColor: 'transparent',
      padding: '3px 0 6px 0',
      border: 'none',
      outline: 'none',
      height: '100%',
      boxSizing: 'border-box',
      display: 'block',
      fontSize: theme.autocomplete.fontSizeMedium,
      minWidth: 0,
      flexGrow: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    '& input::placeholder': {
      color: theme.autocomplete.placeholder
    },
    '&.selected $field': {
      borderBottomColor: theme.autocomplete.bordered.borderColor
    },
    '&.focus $field': {
      borderBottomColor: theme.autocomplete.active.borderColor
    },
    '&.focus $label': {
      color: theme.autocomplete.active.colorLabel
    },
    '&.error $field': {
      borderBottomColor: theme.autocomplete.error.borderColor,
      color: theme.autocomplete.error.colorLabel,
      '& $chips': {
        color: theme.autocomplete.error.colorLabel
      }
    },
    '&.error $label': {
      color: theme.autocomplete.error.colorLabel
    },
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default'
    },
    '&.bordered': {
      paddingTop: 20,
      '&.focus $field': {
        borderColor: theme.autocomplete.active.borderColor
      },
      '&.error $field': {
        borderColor: theme.autocomplete.error.borderColor
      },
      '& $field': {
        display: 'flex',
        alignItems: 'center',
        borderColor: theme.autocomplete.bordered.borderColor,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: theme.autocomplete.bordered.borderRadius
      },
      '& $label': {
        transform: 'translate(0px, -19px)'
      },
      '&$large': {
        '& $label': {
          transform: 'translate(0px, -24px)',
          fontSize: 14
        }
      },
      '&.unspaced': {
        padding: 0,
        margin: 0
      }
    }
  },
  field: {
    display: 'flex',
    boxSizing: 'border-box',
    borderBottomColor: theme.autocomplete.borderColor,
    borderBottomStyle: 'solid',
    position: 'relative',
    transition: theme.transition(['all']),
    borderBottomWidth: theme.autocomplete.borderWidthMedium,
    alignItems: 'center'
  },
  rightText: {
    cursor: 'pointer',
    flex: '0 0 auto',
    color: theme.autocomplete.rightTextColor
  },
  fieldInput: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    minWidth: 0,
    flexGrow: 1,
    alignItems: 'center',
    color: theme.autocomplete.textColor
  },
  paddings: {
    boxSizing: 'border-box',
    paddingTop: 2,
    '&.bordered': {
      '&$small': {
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 1
      },
      '&$medium': {
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 3,
        paddingBottom: 1
      },
      '&$large': {
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 7,
        paddingBottom: 5
      }
    }
  },
  label: {
    position: 'absolute',
    top: 20,
    zIndex: 1,
    fontSize: theme.autocomplete.fontSizeLabel,
    color: theme.autocomplete.colorLabel,
    transform: 'translate(0px, -19px)',
    transformOrigin: 'left top 0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
  },
  helperText: {
    fontSize: theme.autocomplete.fontSizeHelper,
    marginTop: 4,
    '&.error': {
      color: theme.autocomplete.error.colorLabel
    }
  },
  chips: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 1,
    flexWrap: 'wrap'
  },
  searchList: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '8px 0',
    maxHeight: '288px',
    overflow: 'auto',
    backgroundColor: theme.autocomplete.searchBackgroundColor,
    boxShadow: theme.autocomplete.boxShadow,
    borderRadius: 6,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.autocomplete.bordered.borderColor,
    transition: theme.transition(['height'])
  },
  searchResult: {
    maxHeight: 280,
    overflow: 'scroll',
    zIndex: 10
  },
  large: {
    '& $fieldInput': {
      marginTop: 0,
      marginBottom: 0
    }
  },
  medium: {
    '& input': {
      fontSize: theme.autocomplete.fontSizeMedium
    },
    '& input::placeholder': {
      color: theme.autocomplete.placeholder
    }
  },
  small: {
    '& input': {
      fontSize: theme.autocomplete.fontSizeSmall
    },
    '& $searchList': {
      padding: '4px 0'
    },
    '& $fieldInput': {
      marginTop: 0,
      marginBottom: 0,
      '& > div': {
        marginBottom: 1
      }
    }
  },
  popoverContent: {
    display: 'flex',
    '&:not(.unspaced).contentAnchor_left_top.bindingAnchor_left_bottom': {
      marginTop: -20
    }
  }
});
exports.default = _default;